import cloneDeep from 'lodash/cloneDeep';

let modules = null;
let droits = null;

function initNewDroit(moduleName, categorieName, droitName) {
  let ordreDroit = droits.indexOf(droitName);
  if (ordreDroit === -1) {
    droits.push(droitName);
    ordreDroit = droits.indexOf(droitName);
  }
  const newDroit = {
    link: moduleName + '.' + categorieName + '.' + droitName,
    nameDroit: droitName,
    selected: false,
    ordre: ordreDroit,
  };
  return newDroit;
}

function initNewCategorie(moduleName, categorieName, droitName) {
  const infoModule = modules.find((el) => { return el.name === moduleName; });
  let orderCategorie = infoModule.categorie.indexOf(categorieName);
  if (orderCategorie === -1) {
    infoModule.categorie.push(categorieName);
    orderCategorie = infoModule.categorie.indexOf(categorieName);
  }
  const newCategorie = {
    name: categorieName,
    droit: [],
    ordre: orderCategorie,
  };
  newCategorie.droit.push(initNewDroit(moduleName, categorieName, droitName));
  return newCategorie;
}

function initNewModule(moduleName, categorieName, droitName) {
  let infoModule = modules.find((el) => { return el.name === moduleName; });
  if (infoModule === undefined) {
    modules.push({ name: moduleName, image: '', categorie: [] });
    infoModule = modules.find((el) => { return el.name === moduleName; });
  }
  const newModule = {
    name: infoModule.name,
    categorie: [],
    selected: false,
    image: infoModule.image,
    ordre: modules.indexOf(infoModule),
  };
  newModule.categorie.push(initNewCategorie(moduleName, categorieName, droitName));
  return newModule;
}

function orderDroitPermission(tableauMisEnForme) {
  tableauMisEnForme.sort((a, b) => {
    return a.ordre - b.ordre;
  });
  tableauMisEnForme.forEach((module) => {
    module.categorie.sort((a, b) => {
      return a.ordre - b.ordre;
    });
    module.categorie.forEach((categorie) => {
      categorie.droit.sort((a, b) => {
        return a.ordre - b.ordre;
      });
    });
  });
  return tableauMisEnForme;
}

export default function generationTableauDesRoles(permissionTableau, allModules, allDroits) {
  // Ajout d'un cloneDeep pour ne pas inpacter allModules et allDroits si ils sont réutiliser apres
  modules = cloneDeep(allModules);
  droits = cloneDeep(allDroits);
  const tableauMisEnForme = [];
  permissionTableau.forEach((el) => {
    const splitUrl = el.name.split('.');

    if (splitUrl.length !== 3) return; // ce return est a cause de Boilerplate module indésirable

    const moduleName = splitUrl[0];
    const categorieName = splitUrl[1];
    const droitName = splitUrl[2];

    const moduleExist = tableauMisEnForme.find((el) => { return el.name === moduleName; });
    let categorieExist = null;
    let droitExist = null;

    if (moduleExist !== undefined) {
      categorieExist = moduleExist.categorie.find((el) => { return el.name === categorieName; });
    } else {
      tableauMisEnForme.push(initNewModule(moduleName, categorieName, droitName));
      return;
    }

    if (categorieExist !== undefined) {
      droitExist = categorieExist.droit.find((el) => { return el.name === droitName; });
    } else {
      moduleExist.categorie.push(initNewCategorie(moduleName, categorieName, droitName));
      return;
    }

    if (droitExist === undefined) {
      categorieExist.droit.push(initNewDroit(moduleName, categorieName, droitName));
    }
  });
  orderDroitPermission(tableauMisEnForme);
  return tableauMisEnForme;
}
